import { createMemroyTokenService } from '../memory-token.service'

export const memoryTokenService = createMemroyTokenService()
